import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarClock } from 'lucide-react';
import { API_URL } from '@/config/api';

let cachedDates = null;

export const BookedDateHint = ({ date }) => {
  const [booked, setBooked] = useState(cachedDates);

  useEffect(() => {
    if (cachedDates) return;
    axios.get(`${API_URL}/bookings/booked-dates`)
      .then(res => {
        cachedDates = {};
        (res.data.booked_dates || []).forEach(d => { cachedDates[d.date] = d.count; });
        setBooked(cachedDates);
      })
      .catch(() => {});
  }, []);

  if (!date || !booked || !booked[date]) return null;

  return (
    <div className="flex items-start gap-2 mt-2 px-3 py-2 rounded-lg bg-amber-500/10 border border-amber-500/30" data-testid="booked-date-hint">
      <CalendarClock className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
      <p className="text-xs text-amber-400">
        Heads up — this date already has {booked[date] > 1 ? `${booked[date]} bookings` : 'a booking'}.
        We may still be able to accommodate you; send your request and we&apos;ll confirm availability.
      </p>
    </div>
  );
};
